import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Motivo de Bloqueio',
        path: '/biblioteca/bibmotivobloqueio',
        name: 'bibmotivobloqueio',
        component: () => import('@/views/biblioteca/bibmotivobloqueio/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVOBLOQUEIOUSUARIONOVO_MENU_1300801499],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Motivo de Bloqueio',
        path: '/biblioteca/bibmotivobloqueio/cadastro/:id?',
        parent: 'bibmotivobloqueio',
        name: 'bibmotivobloqueio_create',
        component: () => import('@/views/biblioteca/bibmotivobloqueio/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_MOTIVOBLOQUEIOUSUARIONOVO_MENU_1300801499],
        },
        goesToMenu: true,
    },
]
